import script from "./HomeSuporteView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSuporteView.vue?vue&type=script&setup=true&lang=js"

import "./HomeSuporteView.vue?vue&type=style&index=0&id=62f140f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f140f8"]])

export default __exports__